<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item :label="$t('member.memberName')" class="custom-item">
          <el-input
            :placeholder="$t('member.memberName')"
            v-model="listQuery.memberName"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('member.cardNo')" class="custom-item">
          <el-input
            :placeholder="$t('member.cardNo')"
            v-model="listQuery.cardNo"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item
          v-if="componentType === 'childMember'"
          :label="$t('company.companyName')"
          class="custom-item"
        >
          <el-select
            v-model="listQuery.companyId"
            :placeholder="$t('company.companyName')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="item in companyLists"
              :key="item.key"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.status')" class="custom-item">
          <el-select
            v-model="listQuery.status"
            :placeholder="$t('table.status')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in statusType"
              :key="index"
              :label="item"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('member.phoneNum')" class="custom-item">
          <el-input
            :placeholder="$t('member.phoneNum')"
            v-model="listQuery.phoneNum"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('member.carNo')" class="custom-item">
          <el-input
            :placeholder="$t('member.carNo')"
            v-model="listQuery.carNo"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('company.memberGrade')" class="custom-item">
          <el-select
            v-model="listQuery.memberGradeId"
            :placeholder="$t('company.memberGrade')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item,index) in gradeLists"
              :key="index"
              :label="item.gradeName"
              :value="item.gradeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!(empinfo.groupId === empinfo.stationId)"
          :label="$t('company.station')"
          class="custom-item"
        >
          <el-select
            v-model="listQuery.optStationId"
            :placeholder="$t('company.station')"
            class="filter-item"
          >
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item,index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <p />
      <p style="text-align:center">
        <el-button
          v-waves
          v-loading.fullscreen.lock="listLoading"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
        <el-button
          v-if="componentType === 'retail'"
          class="filter-item"
          style="margin-left: 10px;"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >开户</el-button>
      </p>
    </div>
    <el-row>
      <el-col :offset="18">
        <h3>
          余额：{{ totalAmt }}
          <!--&nbsp;预授权金额：{{ totalFrozen }}-->
        </h3>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column :label="$t('member.memberId')" align="center" width="95px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.memberName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.memberGradeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberGradeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.cardNo')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.cardNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.phoneNum')" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.phoneNum }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.carNo')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.carNo | blankFilter }}</span>
          <span v-if="scope.row.otherCarNo">,{{ scope.row.otherCarNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.balanceAmt')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.frozenAmt')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.frozenAmt }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('member.point')" align="center" width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.point }}</span>
        </template>
      </el-table-column>-->
      <el-table-column v-if="componentType === 'childMember'" label="车队名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName | blankFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车环编号" width="80px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.carRing }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.status')" width="80px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('member.createdTime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.actions')"
        align="center"
        width="180px"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link" style="padding:0px 10px">
              查询
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span style="display:block;" @click="redirectPage('amount',scope.row)">资金明细</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display:block;" @click="redirectPage('fuel',scope.row)">加油记录</span>
              </el-dropdown-item>
              <!--              <el-dropdown-item>
                <span style="display:block;" @click="redirectPage('point',scope.row)">积分记录</span>
              </el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="scope.row.status!=-1" :hide-on-click="false" style="margin-left:20px">
            <span class="el-dropdown-link" style="padding:0px 10px">
              操作
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span
                  v-if="scope.row.status==1"
                  style="display:block;"
                  @click="handleModifyStatus(scope.row)"
                >冻结</span>
                <span v-else style="display:block;" @click="handleModifyStatus(scope.row)">解冻</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display:block;" @click="handleUpdate(scope.row)">修改资料</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span
                  v-if="(scope.row.companyType !== 3)"
                  style="display:block;"
                  @click="handleCharge(scope.row)"
                >客户充值</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span
                  v-if="(scope.row.companyType !== 3)"
                  style="display:block;"
                  @click="handleRefund(scope.row)"
                >客户退款</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display:block;" @click="handleClose(scope.row)">注销客户</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-date" /> 基本资料
          </span>
          <el-form
            ref="dataForm"
            :inline="true"
            :rules="rules"
            :model="temp"
            class="demo-form-inline"
            label-position="right"
            label-width="150px"
          >
            <el-form-item :label="$t('member.memberName')" prop="memberName">
              <el-input v-model="temp.memberName" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.phoneNum')" prop="phoneNum">
              <el-input v-model="temp.phoneNum" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.timesUpperLimit')" prop="timesUpperLimit">
              <el-input v-model.number="temp.timesUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('company.memberGrade')" prop="memberGradeId">
              <el-select
                v-model="temp.memberGradeId"
                class="filter-item"
                placeholder="请选择"
                @change="bindChange"
              >
                <el-option
                  v-for="(item,index) in gradeLists"
                  :key="index"
                  :label="item.gradeName"
                  :value="item.gradeId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('member.dailyUpperLimit')" prop="dailyUpperLimit">
              <el-input v-model.number="temp.dailyUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('member.monthUpperLimit')" prop="monthUpperLimit">
              <el-input v-model.number="temp.monthUpperLimit" maxlength="7" />
            </el-form-item>
            <el-form-item :label="$t('member.cardNo')" prop="cardNo">
              <el-input v-model="temp.cardNo" maxlength="8" />
            </el-form-item>
            <el-form-item :label="$t('company.companyName')" prop="companyId">
              <el-select :disabled="true" :placeholder="temp.companyName" style="width:190px" />
            </el-form-item>
            <el-form-item v-if="empinfo.isAllStation==0" label="所属油站" required>
              <el-input v-model="temp.stationName" maxlength="10" disabled />
            </el-form-item>
            <el-form-item
              v-if="empinfo.isAllStation!=0&&dialogStatus=='create'"
              label="所属油站"
              prop="optStationId"
            >
              <el-select
                v-model="temp.optStationId"
                class="filter-item"
                placeholder="请选择"
                @change="selectStations()"
              >
                <el-option
                  v-for="(item,index) in stationLists"
                  :key="index"
                  :label="item.stationName"
                  :value="item.stationId"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="empinfo.isAllStation!=0&&dialogStatus=='update'"
              label="所属油站"
              prop="optStationId"
            >
              <el-select
                v-model="temp.optStationId"
                class="filter-item"
                placeholder="请选择"
                disabled
                @change="selectStations()"
              >
                <el-option
                  v-for="(item,index) in stationLists"
                  :key="index"
                  :label="item.stationName"
                  :value="item.stationId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('member.carNo')+1" prop="carNo">
              <el-input v-model="temp.carNo" maxlength="10" />
            </el-form-item>
            <el-form-item :label="$t('member.carNo')+2" prop="carNo">
              <el-input v-model="carNoArray[0]" maxlength="10" />
            </el-form-item>
            <el-form-item :label="$t('member.carNo')+3" prop="carNo">
              <el-input v-model="carNoArray[1]" maxlength="10" />
            </el-form-item>
            <el-form-item :label="$t('member.carNo')+4" prop="carNo">
              <el-input v-model="carNoArray[2]" maxlength="10" />
            </el-form-item>
            <el-form-item :label="$t('member.birthday')" prop="birthday">
              <el-input v-model="temp.birthday" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.idCard')" prop="idCard">
              <el-input v-model="temp.idCard" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('member.memo')" prop="memo">
              <el-input v-model="temp.memo" maxlength="50" />
            </el-form-item>
            <el-form-item label="车环号">
              <el-input v-model="temp.carRing" :disabled="carRingEnableDisab" maxlength="100" />
            </el-form-item>
            <el-row :gutter="18">
              <el-col :span="6">
                <el-form-item prop="checkFuelPwd">
                  <el-checkbox
                    v-model="memberCheckFlags.checkFuelPwd"
                    name="checkFuelPwd"
                    @change="handleCheck"
                  >{{ $t('member.checkFuelPwd') }}</el-checkbox>
                  <el-input
                    v-model="temp.fuelPwd"
                    :disabled="!memberCheckFlags.checkFuelPwd"
                    maxlength="6"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label=" " prop="checkCarNo">
                  <el-checkbox
                    v-model="memberCheckFlags.checkCarNo"
                    style="margin-left:80%"
                    name="checkCarNo"
                    border
                    size="medium"
                    @change="handleCheck"
                  >限车牌</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="padding-left:5%">
                <!--                <el-form-item label=" " prop="checkEmpCard">
                  <el-checkbox
                    v-model="memberCheckFlags.checkEmpCard"
                    style="margin-left:80%"
                    name="checkEmpCard"
                    border
                    size="medium"
                    @change="handleCheck"
                  >校验员工卡</el-checkbox>
                </el-form-item>-->
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="用户权限">
          <el-form>
            <el-row :gutter="4">
              <el-col :span="7">
                <el-form-item prop="fuelStations">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="memberCheckFlags.checkAllConsume"
                    name="isAllFuel"
                    @change="handleCheckAllChange"
                  >全选({{ $t('member.isAllFuel') }})</el-checkbox>
                  <el-main style="height: 200px;padding-left:0px">
                    <el-checkbox-group
                      v-model="tempFuelStations"
                      @change="handleCheckedCitiesChange"
                    >
                      <el-checkbox
                        v-for="item in stationLists"
                        :label="item.stationId"
                        :key="item.stationId"
                      >{{ item.stationName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item prop="chargeStations">
                  <el-checkbox
                    :indeterminate="isIndeterminate2"
                    v-model="memberCheckFlags.checkAllRecharge"
                    name="isAllCharge"
                    @change="handleCheckAllChange"
                  >全选({{ $t('member.isAllCharge') }})</el-checkbox>
                  <el-main style="height: 200px;padding-left:0px">
                    <el-checkbox-group
                      v-model="tempChargeStations"
                      @change="handleCheckedCitiesChange2"
                    >
                      <el-checkbox
                        v-for="item in stationLists"
                        :label="item.stationId"
                        :key="item.stationId"
                      >{{ item.stationName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="oilProds">
                  <el-checkbox
                    :indeterminate="isIndeterminate3"
                    v-model="memberCheckFlags.checkAllProds"
                    name="isAllProds"
                    @change="handleCheckAllProds"
                  >全选(全部油品)</el-checkbox>
                  <el-main style="width: 320px;padding-left:0px">
                    <el-checkbox-group v-model="tempProdList" @change="handleCheckedCitiesChange3">
                      <el-checkbox
                        v-for="item in prodLists"
                        :label="item.prodId"
                        :key="item.prodId"
                      >{{ item.prodStandard + '-' +item.prodName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button
          v-if="dialogStatus=='create'"
          type="primary"
          @click="createData"
        >{{ $t('table.confirm') }}</el-button>
        <el-button v-else type="primary" @click="updateData">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogPvVisible" title="会员充值" width="600px">
      <el-form
        ref="chargeForm"
        :rules="charagerules"
        :model="charage"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item label="会员名称">
          <el-input v-model="charage.memberName" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('company.amt')" prop="amt">
          <el-input v-model.number="charage.amt" maxlength="8" />
        </el-form-item>
        <el-form-item :label="$t('company.giftAmt')" prop="giftAmt">
          <el-input v-model.number="charage.giftAmt" maxlength="8" />
        </el-form-item>
        <el-form-item label="支付方式" prop="payTypeId">
          <el-select v-model="charage.payTypeId" class="filter-item" placeholder="请选择">
            <el-option
              v-for="(item,index) in payLists"
              :key="index"
              :label="item.payTypeName"
              :value="item.payTypeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.memo')" prop="memo">
          <el-input v-model="charage.memo" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPvVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="optcharge()">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogRefundVisible" title="会员退款" width="600px">
      <el-form
        ref="refundForm"
        :rules="refundRules"
        :model="refund"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item label="会员名称">
          <el-input v-model="refund.memberName" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('company.ramt')" prop="amt">
          <el-input v-model.number="refund.amt" maxlength="8" />
        </el-form-item>
        <el-form-item :label="$t('company.memo')" prop="memo">
          <el-input v-model="refund.memo" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefundVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="optRefund">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogCloseVisible" title="会员注销" width="600px">
      <el-form
        ref="memberForm"
        :model="close"
        :rules="closeRules"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <h4 style="color:#ff3300;text-align: center;">警告！销户后，该加油卡不能使用，并且不可恢复.</h4>
        <el-form-item label="会员名称">
          <el-input v-model="close.memberName" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('company.memo')" prop="memo">
          <el-input v-model="close.memo" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCloseVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="optClose">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="dialogAmountVisible"
      :visible.sync="dialogAmountVisible"
      :title="dialogTitle"
      width="80%"
    >
      <HistoryAmount :company-id="0" :member-id="commonParam" :flag="true" />
    </el-dialog>
    <el-dialog
      v-if="dialogFuelVisible"
      :visible.sync="dialogFuelVisible"
      :title="dialogTitle"
      width="1020px"
    >
      <HistoryFuel :company-id="0" :member-id="commonParam" :flag="true" />
    </el-dialog>
    <el-dialog
      v-if="dialogPointVisible"
      :visible.sync="dialogPointVisible"
      :title="dialogTitle"
      width="1020px"
    >
      <HistoryPoint :company-id="0" :member-id="commonParam" :flag="true" />
    </el-dialog>
  </div>
</template>

<script>
import {
  memberDetail,
  memberClose,
  memberList,
  createMember,
  updateMember,
  memberFrozen,
  addCharge,
  addRefund,
  fetchTotalMember
} from '@/api/member'
import { gradeList } from '@/api/grade'
import { stationList } from '@/api/station'
import { fetchList } from '@/api/company'
import { listPayType } from '@/api/setting'
import HistoryFuel from '@/components/Record/HistoryFuel'
import HistoryAmount from '@/components/Record/HistoryAmount'
import HistoryPoint from '@/components/Record/HistoryPoint'
import waves from '@/directive/waves' // 水波纹指令
import createUniqueString from '@/utils/createUniqueString'
import { isNumber } from '@/utils/validate'
import { getEmpInfo, getUserPermissions } from '../../../utils/auth'
import { listProd } from '@/api/product'
import { checkEmpPwd } from '@/api/setting'
const typeOptions = [
  { value: 1, label: '总帐支付' },
  { value: 2, label: '子账支付' }
]
const statusMap = { '-1': '销户', '0': '冻结', '1': '正常' }
const emp = getEmpInfo()
export default {
  name: 'ComplexTable',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
      for (const key in typeOptions) {
        if (typeOptions[key].value === type) {
          return typeOptions[key].label
        }
      }
    },
    blankFilter (val) {
      if ((!val && val !== 0) || val === 'null' || val === 'undefined') {
        return ''
      } else {
        return val
      }
    }
  },
  components: {
    HistoryFuel,
    HistoryAmount,
    HistoryPoint
  },
  data () {
    const checkPWD = (rule, value, callback) => {
      if (this.temp.checkFuelPwd && !value) {
        return callback(new Error('加油密码不能为空'))
      }
      callback()
    }
    var checkfuelStations = (rule, value, callback) => {
      if (!this.temp.isAllFuel && value.length === 0) {
        return callback(new Error('消费站点必须选择'))
      }
      callback()
    }
    var checkchargeStations = (rule, value, callback) => {
      if (!this.temp.isAllCharge && value.length === 0) {
        return callback(new Error('充值站点必须选择'))
      }
      callback()
    }
    const checkPhone = (rule, value, callback) => {
      if (!isNumber(value)) {
        callback(new Error('请输入正确电话'))
      } else {
        callback()
      }
    }
    const checkAmt = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('金额不能为空'))
      }
      value = Number.parseFloat(value)
      if (value < 0) {
        callback(new Error('金额必须大于0！'))
      } else if (value > 1000000) {
        callback(new Error('金额必须不能大于1000000！'))
      } else {
        callback()
      }
      // if (!Number.isInteger(value)) {
      //   callback(new Error('请输入数字值'))
      // } else {
      //   value = Number.parseFloat(value)
      //   if (value < 0) {
      //     callback(new Error('金额必须大于0！'))
      //   } else if (value > 1000000) {
      //     callback(new Error('金额必须不能大于1000000！'))
      //   } else {
      //     callback()
      //   }
      // }
    }
    const checkNum = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          value = Number.parseFloat(value)
          if (value < 0) {
            callback(new Error('金额必须大于0！'))
          } else if (value > 9999999) {
            callback(new Error('金额必须不能大于9999999！'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    return {
      totalAmt: 0,
      totalFrozen: 0,
      empinfo: emp,
      bool: true,
      componentType: 'retail',
      stationLists: [],
      checkAll: false,
      stationValues: [],
      prodLists: [],
      prodIdList: [],
      isIndeterminate: true,
      checkAll2: false,
      isIndeterminate2: true,
      isIndeterminate3: false,
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        memberType: 1,
        page: 1,
        limit: 20,
        status: '',
        memberName: '',
        companyId: '',
        memberGradeId: '',
        optStationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : '',
        cardNo: '',
        phoneNum: '',
        carNo: ''
      },
      isAllStation: getEmpInfo().isAllStation,
      showReviewer: false,
      temp: {
        memberId: 0,
        phoneNum: '',
        memberName: '',
        memberGradeId: '',
        memberGradeName: '',
        cardNo: '',
        carNo: '',
        timesUpperLimit: 9999,
        dailyUpperLimit: 9999,
        monthUpperLimit: 9999,
        checkCarNo: '',
        checkEmpCard: '',
        checkFuelPwd: false,
        fuelPwd: '',
        isAllFuel: false,
        fuelStations: [],
        isAllCharge: false,
        isAllProd: 1,
        allowProd: [],
        chargeStations: [],
        memo: '',
        birthday: '',
        idCard: '',
        carRing: '',
        companyId: 0,
        companyName: '',
        stationName: '',
        optStationId: ''
      },
      carNoArray: [], // 新需求-多个车牌
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogPvVisible: false,
      dialogRefundVisible: false,
      dialogCloseVisible: false,
      types: typeOptions,
      statusType: statusMap,
      rules: {
        monthUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            min: 0,
            trigger: 'blur'
          }
        ],
        dailyUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            trigger: 'blur',
            min: 0
          }
        ],
        timesUpperLimit: [
          {
            type: 'number',
            required: true,
            message: '必须填写，且大于0',
            trigger: 'blur',
            min: 0
          }
        ],
        memberName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phoneNum: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '长度在 7 到 50 个字符,且为数字',
            trigger: 'blur',
            validator: checkPhone
          }
        ],
        cardNo: [
          { required: false, message: '必须填写', trigger: 'blur' },
          { min: 8, max: 10, message: '长度在 8 到 10 个字符', trigger: 'blur' }
        ],
        memberGradeId: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        fuelPwd: [{ validator: checkPWD, trigger: 'blur' }],
        fuelStations: [
          {
            type: 'array',
            required: true,
            validator: checkfuelStations,
            trigger: 'change'
          }
        ],
        chargeStations: [
          {
            type: 'array',
            required: true,
            validator: checkchargeStations,
            trigger: 'change'
          }
        ],
        optStationId: [
          { required: true, message: '请选择所属站点', trigger: 'change' }
        ]
      },
      closeRules: {
        memo: [{ required: true, message: '必须填写', trigger: 'blur' }]
      },
      charagerules: {
        companyId: [{ required: true, message: '必须填写', trigger: 'change' }],
        amt: [
          {
            type: 'number',
            required: true,
            message: '请输入正确数字',
            trigger: 'blur'
          },
          { type: 'number', validator: checkAmt, trigger: 'blur' }
        ],
        giftAmt: [{ type: 'number', validator: checkNum, trigger: 'blur' }],
        payTypeId: [{ required: true, message: '必须填写', trigger: 'change' }]
      },
      refundRules: {
        amt: [
          {
            type: 'number',
            required: true,
            message: '请输入正确数字',
            trigger: 'blur'
          }
        ],
        memo: [{ required: true, message: '必须填写', trigger: 'blur' }]
      },
      charage: {
        companyId: '0',
        memberName: '',
        amt: '',
        giftAmt: 0,
        payTypeId: '',
        payTypeName: '',
        memo: ''
      },
      refund: {
        memberName: '',
        amt: '',
        memo: ''
      },
      close: {
        memberId: '',
        memberName: '',
        memo: ''
      },
      payLists: [],
      gradeLists: [],
      companyLists: [],
      dialogTitle: '',
      commonParam: '',
      dialogFuelVisible: false,
      dialogAmountVisible: false,
      dialogPointVisible: false,
      memberCheckFlags: {
        checkFuelPwd: false,
        checkCarNo: false,
        checkEmpCard: false,
        checkAllConsume: false,
        checkAllRecharge: false,
        checkAllProds: true
      },
      tempFuelStations: [],
      tempChargeStations: [],
      tempProdList: [],
      prodNameList: [],
      carRingEnableDisab: false
    }
  },
  watch: {
    $route (to, from) {
      console.log('to:', to, '\nfrom:', from)
    }
  },
  created () {
    if (this.empinfo.isAllStation == 0) {
      this.temp.optStationId = this.empinfo.stationId
      this.temp.stationName = this.empinfo.stationName
    }
    if (this.$route.name === 'retail') {
      this.componentType = 'retail'
      this.listQuery.memberType = 1
    } else if (this.$route.name === 'childMember') {
      this.componentType = 'childMember'
      this.listQuery.memberType = 2
    }
    listProd({}).then((response, err) => {
      if (err) {
        console.log('prodErr', err)
      }
      this.prodLists = response.data.data
      for (let i = 0; i < this.prodLists.length; i++) {
        this.prodNameList[i] = this.prodLists[i].prodName
        this.prodIdList[i] = this.prodLists[i].prodId
      }
    })
    if (this.$route.query.companyId) {
      this.listQuery['companyId'] = this.$route.query.companyId
    }
    gradeList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.gradeLists.push({
            gradeId: obj[key].gradeId,
            gradeName: obj[key].gradeName
          })
        }
      }
    })
    listPayType({ status: 1 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          if (obj[key].payTypeId === 2) {
            continue
          }
          this.payLists.push({
            payTypeId: obj[key].payTypeId,
            payTypeName: obj[key].payTypeName
          })
        }
      }
    })
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName,
            carRingEnable: obj[key].carRingEnable
          })
          this.stationValues.push(obj[key].stationId)
        }
      }
    })
    fetchList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.companyLists.push({
            companyId: obj[key].companyId,
            companyName: obj[key].companyName
          })
        }
      }
    })
    this.handleFilter()
  },
  methods: {
    redirectPage (type, row) {
      this.commonParam = row.memberId
      if (type === 'fuel') {
        this.dialogTitle = row.memberName + ' - 加油记录'
        this.dialogFuelVisible = true
      }
      if (type === 'amount') {
        this.dialogTitle = row.memberName + ' - 资金流水'
        this.dialogAmountVisible = true
      }
      if (type === 'point') {
        this.dialogTitle = row.memberName + ' - 积分记录'
        this.dialogPointVisible = true
      }
    },
    handleClose (row) {
      if (!getUserPermissions('MEMBER_CLOSE')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.dialogCloseVisible = true
            this.close.memberId = row.memberId
            this.close.memberName = row.memberName
            this.$nextTick(() => {
              this.$refs['memberForm'].clearValidate()
            })
          }
        })
      })
    },
    optClose () {
      this.$refs['memberForm'].validate(valid => {
        if (valid) {
          memberClose(this.close).then(res => {
            this.dialogCloseVisible = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList()
          })
        }
      })
    },
    handleRefund (row) {
      if (!getUserPermissions('MEMBER_REFUND')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.dialogRefundVisible = true
            this.refund.memberId = row.memberId
            this.refund.memberName = row.memberName
            this.refund.sourceId = createUniqueString()
            this.$nextTick(() => {
              this.$refs['refundForm'].clearValidate()
            })
          }
        })
      })
    },
    optRefund () {
      this.$refs['refundForm'].validate(valid => {
        if (!valid) return
        addRefund(this.refund).then(res => {
          this.dialogRefundVisible = false
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        })
      })
    },
    handleCharge (row) {
      if (!getUserPermissions('MEMBER_CHARGE')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.charage = {
              companyId: row.companyId,
              memberId: row.memberId,
              memberName: row.memberName,
              amt: '',
              giftAmt: '',
              payTypeId: '',
              payTypeName: '',
              memo: '',
              sourceId: createUniqueString()
            }
            if (this.payLists.length > 0) {
              this.charage.payTypeId = this.payLists[0]['payTypeId']
            }
            this.dialogPvVisible = true
            this.$nextTick(() => {
              this.$refs['chargeForm'].clearValidate()
            })
          }
        })
      })
    },
    optcharge () {
      this.$refs['chargeForm'].validate(valid => {
        if (!valid) return
        if (
          this.charage.giftAmt === '' ||
          this.charage.giftAmt === null ||
          this.charage.giftAmt === undefined
        ) {
          this.charage.giftAmt = 0
        }
        if (
          this.charage.companyId === '' ||
          this.charage.companyId === null ||
          this.charage.companyId === undefined
        ) {
          this.charage.companyId = 0
        }
        if (this.charage.payTypeId) {
          const obj = this.payLists.find(
            o => o.payTypeId === this.charage.payTypeId
          )
          this.charage.payTypeName = obj.payTypeName
        }
        addCharge(this.charage).then(res => {
          this.dialogPvVisible = false
          this.$message({
            message: '充值成功',
            type: 'success'
          })
          this.getList()
        })
        this.$nextTick(() => {
          this.$refs['chargeForm'].clearValidate()
        })
      })
    },
    handleCheck (val, event) {
      if (event.target.name === 'checkFuelPwd') {
        // this.temp.checkFuelPwd = val
        this.memberCheckFlags.checkFuelPwd = val
        this.bool = !val
      } else if (event.target.name === 'checkCarNo') {
        // this.temp.checkCarNo = val
        this.memberCheckFlags.checkCarNo = val
      } else {
        this.memberCheckFlags.checkEmpCard = val
      }
    },
    handleCheckAllChange (val, event) {
      if (event.target.name === 'isAllFuel') {
        // this.temp.fuelStations = val ? this.stationValues : []
        if (val) {
          // this.temp.fuelStations = this.stationValues
          this.tempFuelStations = this.stationValues
          this.checkAll = true
          this.memberCheckFlags.checkAllConsume = true
          this.isIndeterminate = false
        } else {
          // this.temp.fuelStations = []
          this.tempFuelStations = []
          this.checkAll = false
          this.memberCheckFlags.checkAllConsume = false
        }
      } else {
        // this.temp.chargeStations = val ? this.stationValues : []
        if (val) {
          // this.temp.chargeStations = this.stationValues
          this.tempChargeStations = this.stationValues
          this.checkAll2 = true
          this.memberCheckFlags.checkAllRecharge = true
          this.isIndeterminate2 = false
        } else {
          // this.temp.chargeStations = []
          this.tempChargeStations = []
          this.checkAll2 = false
          this.memberCheckFlags.checkAllRecharge = false
        }
      }
    },
    handleCheckAllProds (val) {
      if (val) {
        this.memberCheckFlags.checkAllProds = true
        this.tempProdList = this.prodIdList
      } else {
        this.memberCheckFlags.checkAllProds = false
        this.tempProdList = []
      }
      this.isIndeterminate3 = false
    },
    handleCheckedCitiesChange (value) {
      if (this.stationLists.length === this.tempFuelStations.length) {
        this.memberCheckFlags.checkAllConsume = true
        this.temp.isAllFuel = 1
      }
      const checkedCount = value.length
      this.memberCheckFlags.checkAllConsume = this.checkAll =
        checkedCount === this.stationLists.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.stationLists.length
    },
    handleCheckedCitiesChange2 (value) {
      if (this.stationLists.length === this.tempChargeStations.length) {
        this.memberCheckFlags.checkAllRecharge = true
        this.temp.isAllCharge = 1
      }
      const checkedCount = value.length
      this.memberCheckFlags.checkAllRecharge = this.checkAll2 =
        checkedCount === this.stationLists.length
      this.isIndeterminate2 =
        checkedCount > 0 && checkedCount < this.stationLists.length
    },
    handleCheckedCitiesChange3 (value) {
      const checkedCount = value.length
      this.memberCheckFlags.checkAllProds =
        checkedCount === this.prodIdList.length
      this.isIndeterminate3 =
        checkedCount > 0 && checkedCount < this.prodLists.length
    },
    bindCompany (selVal) {
      // this.temp.companyId = this.companyLists[selVal].companyId
      const company = this.companyLists.find(item => item.companyId === selVal)
      // this.temp.companyName = this.companyLists[selVal].companyName
      if (company) {
        this.temp.companyId = company.companyId
        this.temp.companyName = company.companyName
      } else {
        this.temp.companyId = 0
        this.temp.companyName = ''
      }
    },
    bindChange (selVal) {
      const selGrade = this.gradeLists.find(o => o.gradeId === selVal)
      this.temp.memberGradeId = selGrade.gradeId
      this.temp.memberGradeName = selGrade.gradeName
    },
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      if (this.$route.query.memberType) {
        this.listQuery['memberType'] = this.$route.query.memberType
      }
      memberList(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      fetchTotalMember(this.listQuery).then(resp => {
        const result = resp.data.data
        if (result) {
          this.totalAmt = result.totalBalance
          this.totalFrozen = result.totalFrozen
        } else {
          this.totalAmt = 0
          this.totalFrozen = 0
        }
      })
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus (row) {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            const flag = row.status ? 0 : 1
            memberFrozen({ memberId: row.memberId, status: flag }).then(res => {
              row.status = flag
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.getList()
            })
          }
        })
      })
    },
    resetTemp () {
      this.temp = {
        memberId: 0,
        phoneNum: '',
        memberName: '',
        memberGradeId: '',
        memberGradeName: '',
        cardNo: '',
        carNo: ' ',
        timesUpperLimit: 9999.99,
        dailyUpperLimit: 9999.99,
        monthUpperLimit: 9999.99,
        checkCarNo: '',
        checkEmpCard: '',
        checkFuelPwd: false,
        fuelPwd: '',
        isAllFuel: false,
        fuelStations: [],
        isAllCharge: false,
        chargeStations: [],
        memo: '',
        birthday: '',
        idCard: '',
        companyId: 0,
        companyName: '',
        stationName: '',
        optStationId: ''
      }
      this.carNoArray = []
      if (this.empinfo.isAllStation == 0) {
        this.temp.optStationId = this.empinfo.stationId
        this.temp.stationName = this.empinfo.stationName
      }
    },
    initMemberCheck () {
      this.memberCheckFlags = {
        checkFuelPwd: false,
        checkCarNo: false,
        checkEmpCard: false,
        checkAllConsume: false,
        checkAllRecharge: false
      }
    },
    initSelectStations () {
      this.tempFuelStations = []
      this.tempChargeStations = []
    },
    handleCreate () {
      if (!getUserPermissions('MEMBER_ADD')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.resetTemp()
      if (!this.gradeLists[0]) {
        this.$alert('没有会员等级，请先创建会员等级！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `开户失败！`
            })
          }
        })
        return
      }
      this.temp.memberGradeId = this.gradeLists[0].gradeId
      this.initMemberCheck()
      this.isIndeterminate = false
      this.isIndeterminate2 = false
      // this.
      this.temp.isAllCharge = 0
      this.temp.isAllFuel = 0
      this.temp.isAllProd = 1
      // 默认全选
      /*
      this.tempFuelStations = []
      this.tempChargeStations = []
*/
      this.tempFuelStations = this.stationValues
      this.tempChargeStations = this.stationValues
      this.memberCheckFlags.checkAllConsume = true
      this.memberCheckFlags.checkAllRecharge = true
      this.memberCheckFlags.checkAllProds = true
      this.tempProdList = this.prodIdList
      this.temp.companyId = ''
      if (this.componentType === 'retail') {
        this.temp['creditAmt'] = 0
      } else {
        // 子账户
        this.temp['creditAmt'] = null
      }
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData () {
      console.log(this.carNoArray)
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.temp.fuelStations = Object.assign(
            [],
            this.tempFuelStations
          ).join(',')
          this.temp.chargeStations = Object.assign(
            [],
            this.tempChargeStations
          ).join(',')
          this.temp.allowProd = Object.assign([], this.tempProdList).join(',')
          this.temp.isAllCharge = this.memberCheckFlags.checkAllRecharge ? 1 : 0
          this.temp.isAllFuel = this.memberCheckFlags.checkAllConsume ? 1 : 0
          if (this.stationLists.length === this.tempFuelStations.length) {
            this.temp.isAllFuel = 1
          }
          if (this.stationLists.length === this.tempChargeStations.length) {
            this.temp.isAllCharge = 1
          }
          this.temp.checkEmpCard = this.memberCheckFlags.checkEmpCard ? 1 : 0
          this.temp.checkCarNo = this.memberCheckFlags.checkCarNo ? 1 : 0
          this.temp.checkFuelPwd = this.memberCheckFlags.checkFuelPwd ? 1 : 0
          // this.temp.isAllProd = this.memberCheckFlags ? 1 : 0
          if (this.prodLists.length == this.tempProdList.length) {
            this.temp.isAllProd = 1
          } else {
            this.temp.isAllProd = 0
          }
          if (this.$route.name === 'retail') {
            this.temp['memberType'] = 1
          } else if (this.$route.name === 'childMember') {
            this.temp['memberType'] = 2
          }
          // 新增多车牌需求
          if (this.carNoArray.length != 0) {
            this.temp.otherCarNo = Object.assign([], this.carNoArray).join(',')
          }
          // 新增多车牌需求
          if (this.carNoArray.length != 0) {
            const newCardNo = []
            for (const i in this.carNoArray) {
              if (this.carNoArray[i] != '') {
                newCardNo.push(this.carNoArray[i])
              }
            }
            if (newCardNo.length != 0) {
              this.temp.otherCarNo = Object.assign([], newCardNo).join(',')
            } else {
              this.temp.otherCarNo = ''
              delete this.temp.otherCarNo
            }
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          createMember(this.temp)
            .then(res => {
              loading.close()
              // if (row.data) this.list.unshift(row.data)
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
            })
            .catch(e => {
              loading.close()
              console.log('创建会员失败：', e)
            })
        }
      })
    },
    handleUpdate (row) {
      if (!getUserPermissions('MEMBER_EDIT')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      // 防止修改用户后不刷新页面，显示问题
      this.resetTemp()
      this.initMemberCheck()
      this.initSelectStations()
      memberDetail({ memberId: row.memberId }).then(res => {
        const memberInfo = res.data.data
        console.log(memberInfo)
        this.temp = {
          memberId: memberInfo['memberId'],
          phoneNum: memberInfo['phoneNum'],
          memberName: memberInfo['memberName'],
          memberGradeId: memberInfo['memberGradeId'],
          memberGradeName: memberInfo['memberGradeName'],
          cardNo: memberInfo['cardNo'],
          carNo: memberInfo['carNo'] ? memberInfo['carNo'] : '',
          timesUpperLimit: memberInfo['timesUpperLimit'],
          dailyUpperLimit: memberInfo['dailyUpperLimit'],
          monthUpperLimit: memberInfo['monthUpperLimit'],
          checkCarNo: memberInfo['checkCarNo'],
          checkEmpCard: memberInfo['checkEmpCard'],
          checkFuelPwd: memberInfo['checkFuelPwd'],
          fuelPwd: memberInfo['fuelPwd'],
          isAllFuel: memberInfo['isAllFuel'],
          fuelStations: memberInfo['fuelStations'],
          isAllCharge: memberInfo['isAllCharge'],
          chargeStations: memberInfo['chargeStations'],
          memo: memberInfo['memo'] ? memberInfo['memo'] : '',
          birthday: memberInfo['birthday'] ? memberInfo['birthday'] : '',
          idCard: memberInfo['idCard'] ? memberInfo['idCard'] : '',
          companyId: !memberInfo['companyId'] ? 0 : memberInfo['companyId'],
          companyName: memberInfo['companyName']
            ? memberInfo['companyName']
            : '',
          isAllProd: memberInfo['isAllProd'],
          stationName: memberInfo['optStationName'],
          optStationId: memberInfo['optStationId'],
          carRing: memberInfo['carRing']
        }
        this.tempChargeStations = memberInfo['chargeStationsArray']
        this.tempFuelStations = memberInfo['fuelStationsArray']
        this.memberCheckFlags.checkAllConsume = this.temp.isAllFuel === 1
        this.memberCheckFlags.checkAllRecharge = this.temp.isAllCharge === 1
        this.memberCheckFlags.checkFuelPwd = this.temp.checkFuelPwd === 1
        this.memberCheckFlags.checkCarNo = this.temp.checkCarNo === 1
        this.memberCheckFlags.checkEmpCard = this.temp.checkEmpCard === 1
        this.memberCheckFlags.checkAllProds = this.temp.isAllProd === 1
        if (this.memberCheckFlags.checkAllProds) {
          this.tempProdList = this.prodIdList
        } else {
          this.tempProdList = memberInfo['allProdsArray']
          this.isIndeterminate3 = true
        }
        if (!this.tempFuelStations) {
          this.tempFuelStations = []
        }
        if (!this.tempChargeStations) {
          this.tempChargeStations = []
        }
        // 新需求-多个车牌号拆分
        if (memberInfo.otherCarNo) {
          this.carNoArray = memberInfo.otherCarNo.split(',')
        } else {
          this.carNoArray = []
        }
        this.checkAll =
          this.tempFuelStations.length === this.stationLists.length
        this.isIndeterminate =
          this.tempFuelStations.length > 0 &&
          this.tempFuelStations.length < this.stationLists.length
        this.checkAll2 =
          this.tempChargeStations.length === this.stationLists.length
        this.isIndeterminate2 =
          this.tempChargeStations.length > 0 &&
          this.tempChargeStations.length < this.stationLists.length
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          this.selectStations()
        })
      })
    },
    updateData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          tempData.fuelStations = this.tempFuelStations.join(',')
          tempData.chargeStations = this.tempChargeStations.join(',')
          tempData.checkCarNo = this.memberCheckFlags.checkCarNo ? 1 : 0
          tempData.checkFuelPwd = this.memberCheckFlags.checkFuelPwd ? 1 : 0
          tempData.checkEmpCard = this.memberCheckFlags.checkEmpCard ? 1 : 0
          tempData.isAllCharge = this.memberCheckFlags.checkAllRecharge ? 1 : 0
          tempData.isAllFuel = this.memberCheckFlags.checkAllConsume ? 1 : 0
          tempData.isAllProd = this.memberCheckFlags.checkAllProds ? 1 : 0
          tempData.allowProd = this.tempProdList.join(',')
          // 新增多车牌需求
          if (this.carNoArray.length != 0) {
            const newCardNo = []
            for (const i in this.carNoArray) {
              if (this.carNoArray[i] != '') {
                newCardNo.push(this.carNoArray[i])
              }
            }
            if (newCardNo.length != 0) {
              tempData.otherCarNo = Object.assign([], newCardNo).join(',')
            } else {
              tempData.otherCarNo = ''
              delete tempData.otherCarNo
            }
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          updateMember(tempData)
            .then(() => {
              loading.close()
              this.getList()
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000
              })
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
    selectStations () {
      console.log(this.temp.optStationId)
      console.log(this.stationLists)
      for (const i in this.stationLists) {
        if (this.temp.optStationId === this.stationLists[i].stationId) {
          if (this.stationLists[i].carRingEnable === 0) {
            this.carRingEnableDisab = true
          } else {
            this.carRingEnableDisab = false
          }
          console.log(this.carRingEnableDisab)
          return
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.grid-content {
  padding: 10px 0px;
}
.el-checkbox {
  margin-right: 30px;
}
.el-checkbox + .el-checkbox {
  margin-left: 0px;
}
.el-row {
  padding-left: 15%;
}
</style>
